import {
  ENG_SERVICE,
  SUPPLY_SERVICE,
  QUALITY_SERVICE,
  DEV_SERVICE,
  TOOL_SERVICE,
} from "assets";
import { ReactSVG } from "react-svg";

export const services = [
  {
    icon: <ReactSVG src={TOOL_SERVICE} />,
    title: "Mechanical & Industrial Engineering",
    desc: "Expertise in advanced mechanical and industrial engineering solutions, focusing on innovative design and engineering excellence.",
    href: "",
  },
  {
    icon: <ReactSVG src={DEV_SERVICE} />,
    title: "Systems Engineering",
    desc: "Comprehensive systems engineering services, ensuring optimal performance and reliability in complex defense systems.",
    href: "",
  },
  {
    icon: <ReactSVG src={ENG_SERVICE} />,
    title: "Quality Assurance",
    desc: "Dedicated to delivering the highest quality assurance standards in every project, guaranteeing client satisfaction and product integrity.",
    href: "",
  },
  {
    icon: <img src={QUALITY_SERVICE} alt="quality" />,
    title: "Development and Manufacturing of Armored Vehicles",
    desc: "Specializing in the development and manufacturing of state-of-the-art armored vehicles, tailored to meet specific security requirements.",
    href: "",
  },
  {
    icon: <ReactSVG src={SUPPLY_SERVICE} />,
    title: "Supply of various Military and Security Equipment",
    desc: "Providing a diverse range of top-grade military and security equipment, catered to enhance defense capabilities.",
    href: "",
  },
];
